import { AttachmentPolicyInfoBarId } from '../schema/AttachmentPolicyInfoBarId';
import AccessIssue from '../schema/AccessIssue';
import { assertNever } from 'owa-assert';

export function getInfoBarId(issue: AccessIssue): AttachmentPolicyInfoBarId {
    switch (issue) {
        case AccessIssue.AccessRestricted:
            return AttachmentPolicyInfoBarId.InfoRestrictedAccess;
        default:
            return assertNever(issue);
    }
}
